module.exports = __webpack_public_path__ + "static/media/baynes.d248099c.jpg";